import React from 'react'
import { useEffect, useState} from 'react'
import axios from 'axios'



    
    export const LiveAgentRecord =  (offset) =>
     {
        //console.log("API CAlled"+offset)
           // const [offset, setOffset] = useState(1); 
           return axios.get(process.env.REACT_APP_IP+`/User/getLiveAgentRecord?pageNumber=${offset - 1}&size=50`,
            { withCredentials: true })

           // return ress;

    }
    export const AgentLiveAgentRecord=  (offsetagent) =>
    {
       //console.log("API CAlled"+offset)
          // const [offset, setOffset] = useState(1); 
          return axios.get(process.env.REACT_APP_IP+`/User/getAgentLiveAgentRecord?pageNumber=${offsetagent - 1}&size=50`,
           { withCredentials: true })

          // return ress;

   }

  export const getUserInfo = async () => {
  try {
    const res = await fetch(
      process.env.REACT_APP_IP + "/User/GetUserinfo",
      {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (!res.ok) {
      throw new Error("Failed to fetch user info");
    }

    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Error fetching user info:", err);
    throw err;
  }
};


